import { useEffect, useState } from 'react'
import { AnimatePresence, motion} from 'framer-motion'

//css
import './css/skills.css'
import './css/skill3.css'

const Skill3 = ({ skillCounter, animatinDir }) => {

	return(
				<motion.div 
					initial={animatinDir==="right"?{opacity:0,left:"100%"}:{opacity:0,left:"-100%"}}
					animate={{opacity:1, left:"50%"}}
					transition={{duration:1}}
					exit={animatinDir==="right"?{opacity:0,left:"-50%"}:{opacity:0,left:"100%"}}
					className="skill" 
					id="skill3">
						<div className="skill_head">
							<p>Art & Design</p>
						</div>
						<div className="skill_body" id="skill_3_body">
							<div className="skill_3_body_title">
								This are the tools i use to help bringing your ideas to reality
							</div>
							<div className="skill_3_cards_container">
								<div>
									<p>Design & planning</p>
									<ul>
										<li>Pixlr</li>
										<li>Figma</li>
									</ul>
								</div>
								<div>
									<p>Colors & patterns</p>
									<ul>
										<li>Colorhunt</li>
										<li>Gcolor2</li>
										<li>Html color pikcer</li>
									</ul>
								</div>
								<div>
									<p>Images & icons</p>
									<ul>
										<li>Pixlr</li>
										<li>Iconfinder</li>
										<li>Unsplach</li>
										<li>Freeillustrations</li>
									</ul>
								</div>
								<div>
									<p>Editors & OS</p>
									<ul>
										<li>VS Code</li>
										<li>Sublime Text 3</li>
										<li>Linux Manjaro v4.16</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="skill_footer">
							<i className="fas fa-info-circle"></i>Design is not my domaine, but just in case !
						</div>
				</motion.div>
		)
}

export default Skill3